import { getPageLink } from '@gjensidige/service-dom-utils';

export const Link = {
  getEquinorDeath: () => {
    return getPageLink('claimsFormsPersonalDeathEng').url;
  },
  getEquinorAccidentIllness: () => {
    return getPageLink('claimsFormsPersonalAccidentIllnessEng').url;
  },
};
